export const BENEFITS_CONETNT_1 = {
	id: "1-benfits",
	title: "Dzięki naszym analizom",
	content: [
		"oszczędzicie Państwo pieniądze – zdobyta wiedza o popełnianych błędach oraz Korzyścisystematyczne szkolenie kierowców zwiększy ich świadomość o wykroczeniach",
		"zaoszczędzicie Państwo swój czas i poświęcicie się w całości organizacji płynności swojego transportu – my zajmiemy się odwołaniami do instytucji kontrolnych",
		"unikniecie Państwo niepotrzebnych kar podczas kontroli na drodze – zapewnimy waszej firmie systematyczność pobieranych danych z tachografu cyfrowego oraz kart kierowców",
		"wywiążecie się Państwo z obowiązku zawartego w Ustawie o Czasie Pracy Kierowców – zapewnimy Waszej firmie profesjonalną, jasną i czytelną ewidencję czasu pracy kierowców oraz analizę czasu pracy kierowców.",
	],
};
export const BENEFITS_CONETNT_2 = {
	id: "2-benefits",
	title: "Współpracując z nami",
	content: [
		"Państwa kierowcy będą mogli skorzystać z fachowej pomocy telefonicznej 24h/dobęKorzyści współpraca podczas realizacji transportu",
		"zapewnicie sobie Państwo ciągłość aktywności kierowców",
		"unikniecie Państwo przekroczenia współczynnika ryzyka (obliczanego podczas kontroli na drodze) dzięki wdrażaniu naszych wskazań, a tym samym ustrzeżecie się przed zbędnymi kontrolami w firmie",
		"zwiększycie Państwo prestiż swojej firmy w wyniku prowadzenia przedsiębiorstwa w sposób zgodny z przepisami dotyczącymi czasu pracy kierowców",
		"zwiększycie również Państwo bezpieczeństwo swoich pracowników poprzez zmniejszenie ryzyka niepotrzebnych wypadków i kolizji drogowych",
		"staniecie się Państwo firmą wiarygodną w oczach instytucji kontrolnych",
		"dokonamy dla Państwa analizy w najlepszym na rynku programie 4Trans firmy Inelo oraz SuperTacho firmy Quatro System, z którego korzystają również instytucje kontrolne; indywidualnie dostosujemy nasze usługi do potrzeb Państwa firmy",
	],
};
